module.exports = require("@ember/template");